import { render, staticRenderFns } from "./ListDiscountsTargeted.vue?vue&type=template&id=4c3f7d79&"
import script from "./ListDiscountsTargeted.vue?vue&type=script&lang=ts&"
export * from "./ListDiscountsTargeted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports